module.exports = __webpack_public_path__ + "img/image-spaceport-portrait.1245c57d.jpg";